document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[data-utp-form]');
  if (!form) return;

  const nodesInput = form.querySelector('[data-utp-nodes]');
  const nodesWrapper = form.querySelector('[data-utp-nodes-wrapper]');
  const spoolSelect = form.querySelector('[data-utp-spool-select]');
  const spoolCustom = form.querySelector('[data-utp-spool-custom]');
  const lossInput = form.querySelector('[data-utp-loss]');
  const exportBtn = form.querySelector('[data-utp-export]');
  const resultBox = form.parentElement.querySelector('[data-utp-result]');

  const LIMITE_NORMA = 90;

  // WhatsApp / branding
  const SITE_URL = 'https://sily.mx';
  const WHATSAPP_NUMBER_E164 = '525584218080'; // 55 8421 8080 -> E.164 con +52
  const WHATSAPP_MESSAGE_BASE = 'Hola, quiero cotizar material para mi instalación de cableado. Ya hice el cálculo en la calculadora de bobinas de Sily.mx.';

  // Guardamos el último cálculo para exportar
  let lastReport = null;

  function clampNumber(n, min, max, fallback) {
    const x = Number(String(n).replace(',', '.'));
    if (!Number.isFinite(x)) return fallback;
    return Math.min(max, Math.max(min, x));
  }

  function fmt(x) {
    return (Math.round(x * 10) / 10).toFixed(1);
  }

  function getSpoolLength() {
    const sel = spoolSelect.value;
    if (sel === 'custom') return clampNumber(spoolCustom.value, 1, 100000, 305);
    return clampNumber(sel, 1, 100000, 305);
  }

  // 🔴 Pintar en rojo en vivo si > 90m
  function evaluarNormaInput(input) {
    const raw = clampNumber(input.value, 0, 100000, 0);

    const next = input.nextElementSibling;
    const hasWarn = next && next.classList && next.classList.contains('utp-warning');

    if (raw > LIMITE_NORMA) {
      input.style.border = '2px solid #cc0000';
      input.style.background = '#fff5f5';

      if (!hasWarn) {
        const warning = document.createElement('small');
        warning.className = 'utp-warning';
        warning.style.color = '#990000';
        warning.style.display = 'block';
        warning.style.marginTop = '4px';
        warning.textContent = `⚠️ Fuera de norma TIA-568 (> ${LIMITE_NORMA} m)`;
        input.after(warning);
      }
    } else {
      input.style.border = '';
      input.style.background = '';
      if (hasWarn) next.remove();
    }
  }

  // Heurística First-Fit Decreasing para minimizar desperdicio
  function pack(segments, spoolLen) {
    const sorted = [...segments].sort((a, b) => b.adjusted - a.adjusted);
    const spools = [];

    for (const seg of sorted) {
      let placed = false;

      for (const sp of spools) {
        if (sp.remaining + 1e-9 >= seg.adjusted) {
          sp.items.push(seg);
          sp.used += seg.adjusted;
          sp.remaining -= seg.adjusted;
          placed = true;
          break;
        }
      }

      if (!placed) {
        spools.push({
          used: seg.adjusted,
          remaining: spoolLen - seg.adjusted,
          items: [seg],
        });
      }
    }

    return spools;
  }

  function renderNodeFields(n) {
    nodesWrapper.innerHTML = '';

    for (let i = 1; i <= n; i++) {
      const row = document.createElement('div');
      row.className = 'solar-field';
      row.innerHTML = `
        <label class="solar-label">Nodo/Cámara ${i} (m)</label>
        <input type="number" min="0" step="0.1" class="solar-input" data-utp-node="${i}" placeholder="Ej. 40">
        <small class="solar-help">Distancia estimada (solo ida).</small>
      `;

      const input = row.querySelector('input');

      // ✅ pintar en vivo y invalidar export si cambian datos
      input.addEventListener('input', () => {
        evaluarNormaInput(input);
        lastReport = null;
        if (exportBtn) exportBtn.disabled = true;
      });

      nodesWrapper.appendChild(row);
    }
  }

  function syncSpoolCustom() {
    if (spoolSelect.value === 'custom') {
      spoolCustom.style.display = 'block';
      spoolCustom.value = spoolCustom.value || '305';
    } else {
      spoolCustom.style.display = 'none';
      spoolCustom.value = spoolSelect.value;
    }
  }

  // ===== CSV helpers =====
  function escapeCSV(value) {
    const s = String(value ?? '');
    if (/[;"\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  }

  function downloadCSV(filename, rows) {
    // Excel suele necesitar BOM para UTF-8 (acentos bien)
    const BOM = '\uFEFF';
    // En MX Excel suele usar ; como separador
    const csv = rows.map(r => r.map(escapeCSV).join(';')).join('\r\n');

    const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(url);
  }

  function buildCSVRows(report) {
    const rows = [];

    rows.push(['RESUMEN']);
    rows.push(['Metros por bobina', report.spoolLen]);
    rows.push(['Pérdida (%)', report.lossPct]);
    rows.push(['Bobinas necesarias', report.spools.length]);
    rows.push(['Total sin pérdida (m)', report.totalRaw]);
    rows.push(['Total con pérdida (m)', report.totalAdj]);
    rows.push(['Sobrante total (m)', report.totalWaste]);
    rows.push(['Nodos fuera de norma (>90m)', report.nodosFueraNorma.length]);
    rows.push(['Lista nodos fuera de norma', report.nodosFueraNorma.join(' ') || '']);
    rows.push([]);

    rows.push(['DETALLE POR BOBINA']);
    rows.push(['Bobina', 'Usado (m)', 'Sobrante (m)', 'Nodos en bobina']);
    report.spools.forEach((sp, idx) => {
      const nodos = sp.items
        .slice()
        .sort((a, b) => a.id - b.id)
        .map(s => `Nodo ${s.id} (${fmt(s.raw)}->${fmt(s.adjusted)})${s.raw > LIMITE_NORMA ? ' FUERA_DE_NORMA' : ''}`)
        .join(' | ');
      rows.push([idx + 1, fmt(sp.used), fmt(sp.remaining), nodos]);
    });
    rows.push([]);

    rows.push(['DETALLE POR NODO']);
    rows.push(['Nodo', 'Metros (sin pérdida)', 'Metros (con pérdida)', 'Fuera de norma']);
    report.segments
      .slice()
      .sort((a, b) => a.id - b.id)
      .forEach(s => {
        rows.push([s.id, fmt(s.raw), fmt(s.adjusted), s.raw > LIMITE_NORMA ? 'SI' : 'NO']);
      });

    // ===== Branding + CTA + Disclaimer en CSV =====
    rows.push([]);
    rows.push(['INFO']);
    rows.push(['Cálculos hechos en calculadora de bobinas', SITE_URL]);
    rows.push(['Después de calcular', 'Cotiza el material para tu instalación con nosotros por WhatsApp: 55 8421 8080']);
    rows.push(['Aviso', 'Los cálculos son estimados. Deben ser verificados y ajustados por el instalador y/o proyectista según condiciones reales de obra.']);

    return rows;
  }

  function buildWhatsAppLink(report) {
    // Incluimos un resumen corto en el mensaje
    const resumen = [
      `Bobinas: ${report.spools.length}`,
      `Bobina: ${report.spoolLen}m`,
      `Pérdida: ${report.lossPct}%`,
      `Total con pérdida: ${report.totalAdj}m`
    ].join(' | ');

    const msg = `${WHATSAPP_MESSAGE_BASE}\n\nResumen:\n${resumen}\n\nLink: ${SITE_URL}`;
    return `https://wa.me/${WHATSAPP_NUMBER_E164}?text=${encodeURIComponent(msg)}`;
  }

  if (exportBtn) {
    exportBtn.addEventListener('click', () => {
      if (!lastReport) {
        alert('Primero calcula para poder exportar.');
        return;
      }
      const now = new Date();
      const stamp = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
        '_',
        String(now.getHours()).padStart(2, '0'),
        String(now.getMinutes()).padStart(2, '0')
      ].join('');
      const filename = `calculo_bobinas_utp_sily_${stamp}.csv`;

      const rows = buildCSVRows(lastReport);
      downloadCSV(filename, rows);
    });
  }

  // invalidate on changes
  nodesInput.addEventListener('input', () => {
    renderNodeFields(clampNumber(nodesInput.value, 1, 999, 1));
    resultBox.innerHTML = '<br>';
    lastReport = null;
    if (exportBtn) exportBtn.disabled = true;
  });

  spoolSelect.addEventListener('change', () => {
    syncSpoolCustom();
    resultBox.innerHTML = '<br>';
    lastReport = null;
    if (exportBtn) exportBtn.disabled = true;
  });

  lossInput.addEventListener('input', () => {
    lastReport = null;
    if (exportBtn) exportBtn.disabled = true;
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const n = clampNumber(nodesInput.value, 1, 999, 1);
    const lossPct = clampNumber(lossInput.value, 0, 200, 0);
    const spoolLen = getSpoolLength();

    const segments = [];
    const nodosFueraNorma = [];

    for (let i = 1; i <= n; i++) {
      const input = form.querySelector(`[data-utp-node="${i}"]`);
      const raw = clampNumber(input?.value, 0, 100000, 0);

      if (raw > 0) {
        const adjusted = raw * (1 + lossPct / 100);
        if (raw > LIMITE_NORMA) nodosFueraNorma.push(i);
        segments.push({ id: i, raw, adjusted });
      }
    }

    if (!segments.length) {
      resultBox.innerHTML = '<p>Por favor captura metros en al menos un nodo.</p>';
      lastReport = null;
      if (exportBtn) exportBtn.disabled = true;
      return;
    }

    // ⛔ solo bloquea si (con pérdida) excede la bobina
    const tooLong = segments.find(s => s.adjusted > spoolLen + 1e-9);
    if (tooLong) {
      resultBox.innerHTML = `
        <div style="background:#ffe5e5;border:1px solid #cc0000;color:#990000;padding:12px;border-radius:8px;margin-bottom:12px;">
          <strong>No se puede calcular:</strong><br>
          El Nodo ${tooLong.id} con pérdida queda en <strong>${fmt(tooLong.adjusted)} m</strong>
          y excede la bobina de <strong>${fmt(spoolLen)} m</strong>.
        </div>
      `;
      lastReport = null;
      if (exportBtn) exportBtn.disabled = true;
      return;
    }

    const spools = pack(segments, spoolLen);

    const totalRaw = segments.reduce((a, b) => a + b.raw, 0);
    const totalAdj = segments.reduce((a, b) => a + b.adjusted, 0);
    const totalWaste = spools.length * spoolLen - totalAdj;

    // Guardar reporte para exportar
    lastReport = {
      spoolLen: fmt(spoolLen),
      lossPct: fmt(lossPct),
      segments: segments.map(s => ({ id: s.id, raw: s.raw, adjusted: s.adjusted })),
      nodosFueraNorma: [...nodosFueraNorma],
      spools: spools.map(sp => ({
        used: sp.used,
        remaining: sp.remaining,
        items: sp.items.map(s => ({ id: s.id, raw: s.raw, adjusted: s.adjusted }))
      })),
      totalRaw: fmt(totalRaw),
      totalAdj: fmt(totalAdj),
      totalWaste: fmt(totalWaste)
    };

    if (exportBtn) exportBtn.disabled = false;

    // Alerta norma (NO bloquea)
    let alertaNorma = '';
    if (nodosFueraNorma.length > 0) {
      alertaNorma = `
        <div style="background:#ffe5e5;border:1px solid #cc0000;color:#990000;padding:12px;border-radius:8px;margin-bottom:12px;">
          <strong>⚠️ Advertencia de norma (TIA-568):</strong><br>
          Tienes <strong>${nodosFueraNorma.length}</strong> nodo(s) con longitud mayor a <strong>${LIMITE_NORMA} m</strong>.<br>
          Nodos fuera de norma: <strong>${nodosFueraNorma.join(', ')}</strong><br>
          <span style="font-size:0.9em;opacity:0.9;">*La advertencia no impide el cálculo de bobinas.</span>
        </div>
      `;
    }

    let html = `
      <p><strong>Resultado:</strong></p>
      <ul>
        <li>Bobinas necesarias: <strong>${spools.length}</strong></li>
        <li>Total (sin pérdida): <strong>${fmt(totalRaw)} m</strong></li>
        <li>Total (con pérdida ${lossPct}%): <strong>${fmt(totalAdj)} m</strong></li>
        <li>Sobrante total estimado: <strong>${fmt(totalWaste)} m</strong></li>
      </ul>
      <p><strong>Distribución por bobina:</strong></p>
      <ul>
    `;

    spools.forEach((sp, idx) => {
      const bobinaTieneFueraNorma = sp.items.some(item => item.raw > LIMITE_NORMA);
      const estiloBobina = bobinaTieneFueraNorma ? 'color:#cc0000;font-weight:700;' : '';

      const items = sp.items
        .sort((a, b) => a.id - b.id)
        .map(s => {
          const fueraNorma = s.raw > LIMITE_NORMA;
          const estiloLinea = fueraNorma ? 'color:#cc0000;font-weight:700;' : '';
          const etiqueta = fueraNorma ? ' <span style="color:#cc0000;font-weight:700;">— FUERA DE NORMA</span>' : '';
          return `<span style="${estiloLinea}">Nodo ${s.id}: ${fmt(s.raw)} → <strong>${fmt(s.adjusted)}</strong> m</span>${etiqueta}`;
        })
        .join('<br>');

      html += `
        <li style="margin-bottom:10px;">
          <span style="${estiloBobina}"><strong>Bobina #${idx + 1}</strong></span>
          — Usado: <strong>${fmt(sp.used)} m</strong> · Sobrante: <strong>${fmt(sp.remaining)} m</strong><br>
          ${items}
        </li>
      `;
    });

    html += '</ul>';

    // CTA + WhatsApp + Disclaimer
    const waLink = buildWhatsAppLink(lastReport);
    const ctaBlock = `
      <div style="margin-top:14px;padding:12px;border:1px solid rgba(255,255,255,.15);border-radius:10px;">
        <p style="margin:0 0 10px 0;">
          <strong>Después de calcular:</strong> cotiza el material para tu instalación con nosotros.
        </p>
        <a href="${waLink}" target="_blank" rel="noopener"
           style="display:inline-block;text-decoration:none;padding:10px 14px;border-radius:12px;border:1px solid rgba(0,0,0,.18);background:white;color:black;">
          Quiero cotizar material para mi instalación de cableado
        </a>
        <p style="margin:10px 0 0 0;font-size:0.9em;opacity:0.9;">
          *Los cálculos son estimados. Deben ser verificados y ajustados por el instalador y/o proyectista según condiciones reales de obra.
        </p>
        <p style="margin:8px 0 0 0;font-size:0.9em;opacity:0.9;">
          Cálculos hechos en la calculadora de bobinas de <strong>Sily.mx</strong>: ${SITE_URL}
        </p>
      </div>
    `;

    resultBox.innerHTML = alertaNorma + html + ctaBlock;
  });

  // init
  syncSpoolCustom();
  renderNodeFields(clampNumber(nodesInput.value, 1, 999, 4));
  if (exportBtn) exportBtn.disabled = true;
});
